import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import './style.scss';

class Loading extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      
    }
  }

  render() {
    const { style, messageStyle, message } = this.props;

    let msg = null;
    if (message) {
      let msgStyle = {
        fontSize: '0.9rem',
        textAlign: 'center',
        color: '#000'
      }
      if (messageStyle) {
        msgStyle = { ...msgStyle, ...messageStyle };
      }
      msg = (
        <p style={msgStyle}>{message}</p>
      );
    }

    return (
      <div className="loading-icon" style={style}>
        <FontAwesomeIcon icon={faCircleNotch} spin />
        {msg}
      </div>
    )
  }

}

export default Loading;
